import { useState } from 'react';
import displayrLogo from '@trinity/chat-components/static/logos/displayr.png';
import sigmaLogo from '@trinity/chat-components/static/logos/sigma.png';
import tableauLogo from '@trinity/chat-components/static/logos/tableau.png';
import { Header } from '@trinity/chat-components/components/Modal/Header';
import { Modal } from '@trinity/chat-components/components/Modal/Modal';
import Button from '@trinity/chat-components/components/presentation/Button/Button';
import { DashboardOptionCard } from './DashboardOptionCard';
import styles from './styles/SelectDashboardModal.module.css';

type DashboardOption = {
  key: string;
  label: string;
  logo: React.ReactNode;
};

const DASHBOARD_OPTIONS: DashboardOption[] = [
  {
    key: 'displayr',
    label: 'Displayr',
    logo: <img
      src={displayrLogo}
      alt="Displayr Logo"
      className={styles.logoImg} />,
  },
  {
    key: 'sigma',
    label: 'Sigma',
    logo: <img
      src={sigmaLogo}
      alt="Sigma Logo"
      className={styles.logoImg} />,
  },
  {
    key: 'tableau',
    label: 'Tableau',
    logo: <img
      src={tableauLogo}
      alt="Tableau Logo"
      className={styles.logoImg} />,
  },
];

type Props = {
  open: boolean;
  onClose: () => void;
  onContinue: (selected: string) => void;
};

const chunkArray = <T,>(arr: T[], size: number): T[][] => {
  const result: T[][] = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
};

export const SelectDashboardModal = ({ open, onClose, onContinue }: Props) => {
  const [selected, setSelected] = useState<string | null>(null);
  const optionRows = chunkArray(DASHBOARD_OPTIONS, 2);

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={styles.modal}>
      <Header text="Select Dashboarding Tool" />
      <div className={styles.optionsRow}>
        {optionRows.map((row, rowIdx) => (
          <div
            key={rowIdx}
            className={
              row.length === 1
                ? styles.centeredRow
                : styles.fullRow
            }>
            {row.map(option => (
              <DashboardOptionCard
                key={option.key}
                optionKey={option.key}
                label={option.label}
                logo={option.logo}
                isSelected={selected === option.key}
                onSelect={setSelected}
              />
            ))}
          </div>
        ))}
      </div>
      <div className={styles.footer}>
        <Button.Secondary
          variant="brick"
          onClick={onClose}>
          Cancel
        </Button.Secondary>
        <Button.Primary
          variant="brick"
          disabled={!selected}
          onClick={() => {
            if (selected) {
              onContinue(selected);
            }
          }}>
          Continue
        </Button.Primary>
      </div>
    </Modal>
  );
};
